import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import appConfig from "../../config/appConfig";

export default function CheckoutCancel({ pageTitle }) {
    return (
        <div className="pxl-public-shell">
            <Helmet><title>{pageTitle}</title></Helmet>
            <header className="pxl-public-header">
                <Link to="/">
                    <img src={appConfig.appLogo} alt={appConfig.appName} />
                </Link>
            </header>

            <div className="pxl-checkout-shell">
                <div className="pxl-checkout-card">
                    <div className="pxl-public-message">
                        <h2>Checkout cancelled</h2>
                        <p>No charge was made. You can pick a tier and try again whenever you're ready.</p>
                    </div>
                    <div className="pxl-checkout-actions" style={{ justifyContent: "center", marginTop: 8 }}>
                        <Link to="/pricing" className="pxlCommon-btn">Back to pricing</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
